<template>
  <span class="svg-icon-arrow-chevron-right">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.72008 19.8039C8.42719 19.5111 8.42719 19.0362 8.72008 18.7433L14.5895 12.8731C15.0666 12.396 15.0666 11.6109 14.5895 11.1338L8.71967 5.26402C8.42678 4.97113 8.42678 4.49625 8.71967 4.20336C9.01256 3.91047 9.48744 3.91047 9.78033 4.20336L15.6501 10.0731C16.713 11.136 16.713 12.8709 15.6501 13.9338L9.78074 19.8039C9.48785 20.0968 9.01297 20.0968 8.72008 19.8039Z":fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    isSolid: { type: Boolean },
  }
}
</script>